<template>
  <div class="team-introduction-page">
    <div class="nav-page-box">
      <nav-page-view
        :tabHoverPage="2"
      ></nav-page-view>
    </div>
    <div class="team-introduction-banner">
      <img :src="teamIntroductionBanner" alt="">
      <div>
        <banner-page-view
          :titleObj="teamBannerObj"
        ></banner-page-view>
      </div>
    </div>
    <div class="leader-box">
      <div class="leader-content">
<!--        <div class="ceo flex-middle-x layout-flex-justify-content_space-between">-->
<!--          <img :src="ceoLiuZong" alt="">-->
<!--          <div>-->
<!--            <h5>刘裕</h5>-->
<!--            <h6>资深副总</h6>-->
<!--            <p>拥有十余年的实体企业经营及上市企业管理经验，深谙境内外实业与资本运营相结合运作模式，-->
<!--              对资本市场发展趋势和金融创新模式有深刻理解。熟悉国家金融业相关政策法规，对上市企业项目融资、-->
<!--              并购重组、定向增发、资产证券化（ABS）等资本运作具有丰富的经验。善于将先进的企业管理理念融入-->
<!--              到现代化的金融创新平台中来，熟悉私募股权投融资运作，统筹公司战略发展规划，制订公司年度经营管理计划，-->
<!--              实施目标分解，运用组织、领导、协调、沟通、监督、检查等管理手段，全面提高公司的组织管理、人力资源管理、-->
<!--              财务管理、营销管理水平，增强企业的市场竞争力。</p>-->
<!--          </div>-->
<!--        </div>-->
        <!--<div class="cfo flex-middle-x layout-flex-justify-content_space-between">-->
          <!--<div>-->
            <!--<h5>钱景</h5>-->
            <!--<h6>执行副总</h6>-->
            <!--<p>从事软件开发行业7年，拥有4年架构经验，2年管理经验，擅长敏捷开发，对分布式系统、高并发系统有着深入的理解和实战经验，精通java语言，且熟练掌握js、golang、shell等语言的运用。</p>-->
            <!--<p>个人宣言：只要思想不滑坡，方法总比困难多，一个人牛不算什么，带动整个团队牛才是真的牛。</p>-->
          <!--</div>-->
          <!--<img :src="ceoQianZong" alt="">-->
        <!--</div>-->
<!--        <div class="cfo flex-middle-x layout-flex-justify-content_space-between">-->
<!--          <div>-->
<!--            <h5>卜浩</h5>-->
<!--            <h6>技术总监</h6>-->
<!--            <p>从事软件开发行业7年，拥有4年架构经验，2年管理经验，擅长敏捷开发，对分布式系统、高并发系统有着深入的理解和实战经验，精通java语言，且熟练掌握js、golang、shell等语言的运用。</p>-->
<!--            <p>个人宣言：只要思想不滑坡，方法总比困难多，一个人牛不算什么，带动整个团队牛才是真的牛。</p>-->
<!--          </div>-->
<!--          <img :src="zjBuHao" alt="">-->
<!--        </div>-->
      </div>
    </div>
    <div class="team-banner">
      <team-introduction-swiper
        :bannerList="bannerList"
        :bannerSlidesPerView="bannerSlidesPerView"
        :bannerSlidesPerColumn="bannerSlidesPerColumn"
        @actionClickBanner="actionClickBanner"
      >
      </team-introduction-swiper>
    </div>
    <div class="footer-page-box">
      <footer-page-view
      ></footer-page-view>
    </div>
  </div>
</template>
<script>
  import TeamIntroductionSwiper from '@/components/computer/team/TeamIntroductionSwiper'
  export default {
    name:'',
    data(){
      return {
        bannerSlidesPerView:4,
        bannerSlidesPerColumn:2,
        teamIntroductionBanner: require('./image/team-introduction-banner-image.jpg'),
        teamBannerObj:{
          mainHeading:'团队介绍',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        ceoLiuZong:require('./image/ceo-liuzong.jpg'),
        ceoQianZong:require('./image/ceo-qianzong.jpg'),
        zjBuHao:require('./image/zj-buhao.jpg')
      }
    },
    components:{
      'team-introduction-swiper':TeamIntroductionSwiper
    },
    computed:{
      bannerList(){
        return [
          // {imgUrl:require('./image/rs-biqiu.jpg'), imgUrlManifesto: require('./image/rs-biqiu-manifesto.png'), name:'沈碧秋_', duty:'HR'},
//          {imgUrl:require('./image/cp-yubo.jpg'), imgUrlManifesto: require('./image/cp-yubo-manifesto.png'), name:'于渤_', duty:'助理产品经理'},
          {imgUrl:require('./image/hd-xumiao.jpg'), imgUrlManifesto: require('./image/hd-xumiao-manifesto.png'), name:'徐淼_', duty:'JAVA开发经理'},
          // {imgUrl:require('./image/hd-zhangkai.jpg'), imgUrlManifesto: require('./image/hd-zhangkai-manifesto.png'), name:'张凯_', duty:'JAVA开发工程师'},
          // {imgUrl:require('./image/hd-jiangli.jpg'), imgUrlManifesto: require('./image/hd-jiangli-manifesto.png'), name:'蒋立_', duty:'JAVA开发主管'},
          // {imgUrl:require('./image/hd-sunshuangli.jpg'), imgUrlManifesto: require('./image/hd-sunshuangli-manifesto.png'), name:'孙双利_', duty:'JAVA开发工程师'},
          {imgUrl:require('./image/hd-mengjianli.jpg'), imgUrlManifesto: require('./image/hd-mengjianli-manifesto.png'), name:'孟健立_', duty:'JAVA开发副经理'},
          // {imgUrl:require('./image/hd-wangbaixing.jpg'), imgUrlManifesto: require('./image/hd-wangbaixing-manifesto.png'), name:'王百兴_', duty:'JAVA开发工程师'},
          {imgUrl:require('./image/qd-zhangtiefeng.jpg'), imgUrlManifesto: require('./image/qd-zhangtiefeng-manifesto.png'), name:'张铁峰_', duty:'前端开发主管'},
          {imgUrl:require('./image/qd-pengdashuai.jpg'), imgUrlManifesto: require('./image/qd-pengdashuai-manifesto.png'), name:'彭大帅_', duty:'前端开发工程师'},
          // {imgUrl:require('./image/qd-zhanghaoxuan.jpg'), imgUrlManifesto: require('./image/qd-zhanghaoxuan-manifesto.png'), name:'张浩轩_', duty:'前端开发工程师'},
          {imgUrl:require('./image/qd-wushiling.jpg'), imgUrlManifesto: require('./image/qd-wushiling-manifesto.png'), name:'吴世玲_', duty:'前端开发工程师'},
          // {imgUrl:require('./image/cs-zhangzhijia.jpg'), imgUrlManifesto: require('./image/cs-zhangzhijia-manifesto.png'), name:'张志佳_', duty:'测试主管'},
          // {imgUrl:require('./image/cs-zhaohui.jpg'), imgUrlManifesto: require('./image/cs-zhaohui-manifesto.png'), name:'赵慧_', duty:'测试工程师'}
//          {imgUrl:require('./image/ui-wangbin.jpg'), imgUrlManifesto: require('./image/ui-wangbin-manifesto.png'), name:'王斌_', duty:'设计主管'},
//          {imgUrl:require('./image/ui-lizhaolu.jpg'), imgUrlManifesto: require('./image/ui-lizhaolu-manifesto.png'), name:'李兆鲁_', duty:'产品设计师'}
        ]
      }
    },
    methods:{
      actionClickBanner(index){
        console.log(index);
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .team-introduction-page{
    .nav-page-box{
      width:100%;
    }
    .team-introduction-banner{
      width:100%;
      min-width:1200px;
      position: relative;
      height:450px;
      overflow: hidden;
      img{
        width:100%;
        min-height:450px;
      }
      div{
        width:600px;
        position: absolute;
        top:50%;left:50%;
        transform: translate(-50%, -50%);
      }
    }
    .leader-box{
      width:100%;
      padding-bottom:100px;
      background:$color-4;
      padding-top:30px;
      .leader-content{
        width:1200px;
        margin:auto;
        .ceo, .cfo{
          width:1200px;
          img{
            width:320px;
          }
          div{
            margin-left:75px;
            text-align: left;
            h5{
              font-size:30px;
              color:$color-black;
            }
            h6{
              font-size:20px;
              color:#ffc63d;
              margin-top:10px;
            }
            p{
              font-size:16px;
              color:#555555;
              margin-top:15px;
              margin-right:75px;
              text-align: justify;
            }
          }
        }
        .cfo{
          div{
            text-align: right;
            h5{
              padding-right:73px;
            }
            h6{
              padding-right:73px;
            }
            p{
              text-align: right;
            }
          }
        }
      }
    }
    .team-banner{
      width:1200px;
      margin:30px auto;
      padding-bottom:200px;
      display: none;
    }
  }
</style>
